<template>
  <div class="content">
    <div class="table-responsive">
      <table class="table table-hover table-clean table-vcenter" style="width:100%;">
        <thead>
          <tr>
            <th width="5%" class="text-nowrap">{{ $t('index') }}</th>
            <th width="5%" class="text-nowrap">{{ $t('year') }}</th>
            <th width="10%" class="text-nowrap">{{ $t('name') }}</th>
            <th width="7%" class="text-nowrap">{{ $t('checkIn') }}</th>
            <th width="7%" class="text-nowrap">{{ $t('checkOut') }}</th>
            <th width="7%" class="text-nowrap">{{ $t('document.type') }}</th>
            <th width="7%" class="text-nowrap">{{ $t('document.number') }}</th>
            <th width="7%" class="text-nowrap">{{ $t('dob') }}</th>
            <th width="7%" class="text-nowrap">{{ $t('country') }}</th>
            <th width="10%" class="text-nowrap">{{ $t('room') }}</th>
            <th width="5%" class="text-nowrap">{{ $t('unit') }}</th>
            <th width="7%" class="text-nowrap">{{ $t('updated') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="guest in pagination.guests" @click="(guest.knjigaGostov && guest.knjigaGostov.status == 2) || $router.push('/' + $i18n.locale + '/' + $t('guests') + '/' + guest._id)" v-bind:class="{'bg-white': !guest.knjigaGostov || !guest.knjigaGostov.status || (guest.knjigaGostov.status == 1 && guest.knjigaGostov.casOdhoda !== guest.checkOut.date +'T' + guest.checkOut.time), 'disabled strike-through': guest.knjigaGostov && guest.knjigaGostov.status == 2 }">
            <td>
              <span v-if="guest.knjigaGostov">
                {{guest.knjigaGostov._id.zst}}
              </span>
            </td>
            <td>
              <span v-if="guest.knjigaGostov">
                {{guest.knjigaGostov.casPrihoda | year}}
              </span>
              <span v-else-if="guest.checkIn.date">
                {{guest.checkIn.date | year}}
              </span>
              <span v-else>
                {{guest.booking.night.first | year}}
              </span>
            </td>
            <td v-if="guest.knjigaGostov">
              <span v-if="guest.knjigaGostov.sp == 'M'">Mr.</span>
              <span v-else-if="guest.knjigaGostov.sp == 'F'">Ms.</span>
              {{guest.knjigaGostov.ime}}
              {{guest.knjigaGostov.pri}}
            </td>
            <td v-else>
              <span v-if="guest.gender == 'M'">Mr.</span>
              <span v-else-if="guest.gender == 'F'">Ms.</span>
              <span v-if="guest.name.first || guest.name.last">
                {{guest.name.first}}
                {{guest.name.last}}
              </span>
            </td>
            <td v-if="guest.knjigaGostov">
              {{guest.knjigaGostov.casPrihoda | date}}
            </td>
            <td v-else-if="guest.checkIn.date">
              {{guest.checkIn.date | date}}
            </td>
            <td v-else>
              {{guest.booking.night.first | date}}
            </td>
            <td v-if="guest.knjigaGostov">
                {{guest.knjigaGostov.casOdhoda | date}}
            </td>
            <td v-else-if="guest.checkOut.date">
              {{guest.checkOut.date | date}}
            </td>
            <td v-else>
              {{guest.booking.night.last | checkOut}}
            </td>
            <td v-if="guest.knjigaGostov">
              {{ guest.knjigaGostov.vrstaDok | documentType }}
            </td>
            <td v-else>
              {{ guest.document.type | documentType }}
            </td>
            <td v-if="guest.knjigaGostov">
              {{guest.knjigaGostov.idStDok}}
            </td>
            <td v-else>
              {{guest.document.number}}
            </td>
            <td v-if="guest.knjigaGostov">
              {{guest.knjigaGostov.dtRoj | date}}
            </td>
            <td v-else>
              <span v-if="guest.dob && (guest.dob.day || guest.dob.month || guest.dob.year)">
                {{guest.dob.year + '-' + guest.dob.month + '-' + guest.dob.day | date}}
              </span>
            </td>
            <td v-if="guest.knjigaGostov">
              {{guest.knjigaGostov.drzava  | country }}
            </td>
            <td v-else>
              {{ guest.country | country }}
            </td>
            <td>
              {{guest.room.name}}
            </td>
            <td>
              <span v-if="guest.unit">
                {{guest.unit.name}}
              </span>
            </td>
            <td v-if="guest.knjigaGostov">
              {{guest.knjigaGostov.created | date}}
            </td>
            <td v-else>
              {{guest.updated | date}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="dataTables_wrapper">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="dt-basic_info" role="status" aria-live="polite">
            {{ $t('showing') }}
            {{ pagination.first }}
            <span v-if="pagination.guests.length">
              {{ $t('to') }} {{ pagination.first + pagination.guests.length - 1 }}
            </span>
            {{ $t('of') }}
            {{ pagination.total }}
            {{ $t('entries') }}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <pagination v-bind:pages="pagination.pages"></pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from '../../pagination/Pagination.vue';

import moment from 'moment';

const countryList = require('country-list');

export default {
  name: 'GuestsList',
  components:{
    Pagination
  },
  filters: {
    country: function(countryCode){
      let country = countryList.getData().find(c => c.code == countryCode);
      return country ? country.name : null;
    },
    date: function(date){
      if(!date) return '';
      return moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : "";
    },
    year: function(date){
      if(!date) return '';
      return moment(date).format('YYYY');
    },
    checkOut: function(date){
      if(!date) return '';
      return moment(date).add(1, 'day').format('DD/MM/YYYY');
    },
    documentType: function(type){
      switch(type) {
        case 'P':
          return "Potni list";
        case 'I':
          return "Osebna izkaznica";
        case 'V':
          return "Vozniško dovoljenje"
        case 'O':
          return "Orožni list"
        case 'U':
          return "Upravne listine"
        case 'F':
          return "Obmejna prepustnica"
        case 'H':
          return "Potne listine po mednarodni pogodbi"
        case 'L':
          return "Otroci, državljani RS, brez dokumenta"
        default:
          return "";
      }
    }
  },
  data: () => ({
    pagination: {
      guests: [],
      pages: 1,
      total: 0,
      first: 0
    },
    property: {},
  }),
  created(){

    const propSlug = this.$route.params.property;
    this.property = this.$store.state.host.properties.find(p => p.slug == propSlug);

    this.loadGuests();
  },
  methods: {
    loadGuests: function(){

      let url = '/guests?propertyId=' + this.property._id;

      const page = this.$route.query.page || 1;
      const roomSlug = this.$route.params.room;

      if(roomSlug){
        url += '&roomSlug=' + roomSlug;
      }

      const checkInStart = this.$route.query.checkInStart;
      if(checkInStart){
        url += '&checkInStart=' + checkInStart;
      }

      const checkInEnd = this.$route.query.checkInEnd;
      if(checkInEnd){
        url += '&checkInEnd=' + checkInEnd;
      }

      const checkOutStart = this.$route.query.checkOutStart;
      if(checkOutStart){
        url += '&checkOutStart=' + checkOutStart;
      }

      const checkOutEnd = this.$route.query.checkOutEnd;
      if(checkOutEnd){
        url += '&checkOutEnd=' + checkOutEnd;
      }

      const search= this.$route.query.search;
      if(search){
        url += '&search=' + search;
      }

      const sort = 'booking.night.first';
      const order = '-1';

      url += '&sort=' + sort + '&order=' + order;

      fetch(process.env.VUE_APP_API + url + '&limit=20&skip=' + ((page - 1) * 20), {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        console.log(result);
        if(!result.error){
          return this.pagination = result;
        }
      })
    }
  }
};
</script>

<i18n>
{
  "en": {
    "guests": "guests",
    "name": "Name",
    "year": "Year",
    "index": "Index",
    "checkIn": "Check In",
    "checkOut": "Check Out",
    "document": {
      "type": "Document type",
      "number": "Document number"
    },
    "dob": "Date of Birth",
    "country": "Nationality",
    "room": "Room",
    "unit": "Unit",
    "updated": "Updated",
    "showing": "Showing",
    "to": "to",
    "of": "of",
    "entries": "entries"
  },
  "sl": {
    "guests": "gostje",
    "name": "Ime in priimek",
    "year": "Leto",
    "index": "Zap. št.",
    "checkIn": "Prihod",
    "checkOut": "Odhod",
    "document": {
      "type": "Tip dokumenta",
      "number": "Številka dokumenta"
    },
    "dob": "Rojstni datum",
    "country": "Državljanstvo",
    "room": "Soba",
    "unit": "Enota",
    "updated": "Posodobljeno",
    "showing": "Prikazanih",
    "to": "do",
    "of": "od",
    "entries": "vnosov"
  }
}
</i18n>
